import { render, staticRenderFns } from "./PageSystemFix.vue?vue&type=template&id=607b91f0&"
import script from "./PageSystemFix.vue?vue&type=script&lang=js&"
export * from "./PageSystemFix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports